import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';


const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <ul className="social-icon wow fadeIn" data-wow-delay="0.3s">
                            <li className='social-icon-li'>
                                <a href='https://facebook.com/brainytech' target='_blank' rel='noreferrer'>
                                    <FaFacebookF size={30} color='white' style={{ marginRight: 15 }} />
                                </a>
                            </li>
                            <li className='social-icon-li'>
                                <a href='https://x.com/brainytechnet' target='_blank' rel='noreferrer'>
                                    <FaTwitter size={30} color='white' style={{ marginRight: 15 }} />
                                </a>
                            </li>
                            <li className='social-icon-li'>
                                <a href='https://www.instagram.com/brainytechnet' target='_blank' rel='noreferrer'>
                                    <FaInstagram size={30} color='white' />
                                </a>
                            </li>
                            <li className='social-icon-li'>
                                <a href='https://www.youtube.com/@brainytechnetworks' target='_blank' rel='noreferrer'>
                                    <FaYoutube size={30} color='white' />
                                </a>
                            </li>
                        </ul>

                        <p className="wow bounceIn">
                            Copyright &copy; <a rel="nofollow" href="https://www.brainytech.com.ng" target="_parent"><span>Braintytech Networks Resources Ltd.</span></a> {new Date().getFullYear()} <span> - RC: 1257876</span>
                        </p>

                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer